<template>
  <div class="home">
    <b-container fluid>
      <h1>HRM Reports</h1>
      <b-tabs class="mt-2">
        <b-tab title="Average Time in Hiring Stages By Fiscal Year">
          <b-row>
            <b-col>
              <HiringStageSummary partition-type='Fiscal Year'/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Average Time in Hiring Stages By Division">
          <b-row>
            <b-col>
              <HiringStageSummary partition-type='Division'/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Completed Vacancy-Summary">
          <b-row>
            <b-col>
              <CompletedVacancySummary partition-type='Fiscal Year'/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Completed Vacancy-By Division">
          <b-row>
            <b-col>
              <CompletedVacancySummary partition-type='Division'/>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

    </b-container>
  </div>
</template>

<script>
import PieChart from '@/components/charting/Chart.vue'
import DivisionCount from '@/components/charting/DivisionCount.vue'
import OpenByDivision from '@/components/reports/OpenByDivision.vue'

import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';

// import a particular color scheme
import {Tableau20} from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau';
import HiringStageSummary from "@/components/reports/HiringStageSummary";
import CompletedVacancySummary from "@/components/reports/CompletedVacancySummary";
import pageTitle from '@/mixins/pageTitle'

export default {
  title: 'HRM Reports',
  mixins: [pageTitle],
  components: {
    CompletedVacancySummary,
    HiringStageSummary
  },
  data: () => ({
    loaded: false,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom'
      },
      plugins: {
        colorschemes: {
          scheme: Tableau20
        }
      }
    },
  }),
  mounted() {

  },
  computed: {
    myStyles() {
      return {
        height: '300px',
        position: 'relative'
      }
    },
  }
}
</script>

<style>

</style>